export default __webpack_public_path__ + "static/media/kitchen1-1024w.97d79177.avif";